"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9.216 19.749h-.424c-.145 0-.285-.065-.372-.177s-.128-.265-.099-.406l1.034-5.3H5.587l-.604 1.753a.49.49 0 0 1-.459.329h-.331c-.139 0-.273-.065-.366-.171s-.134-.253-.11-.394l.519-3.385-.519-3.391a.54.54 0 0 1 .11-.394.5.5 0 0 1 .366-.171h.331c.203 0 .389.129.459.329l.604 1.753h3.768L8.321 4.83a.483.483 0 0 1 .471-.582h.424c.186 0 .36.112.436.282l2.625 5.599h5.58c1.341 0 2.433.841 2.433 1.87s-1.092 1.87-2.433 1.87h-5.58l-2.625 5.6a.49.49 0 0 1-.436.276z"
}), 'AirplaneFilled');
